"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Anchor = _interopRequireDefault(require("../../../Atoms/Anchor"));
var _Button = _interopRequireDefault(require("../../../Atoms/Button"));
var _signInOut = _interopRequireDefault(require("./signInOut"));
require("../mobileNavigation.scss");
var _mobileNavListItem = _interopRequireDefault(require("./mobileNavListItem"));
function MobileNavListItems(_ref) {
  var signOutRequest = _ref.signOutRequest,
    signInRedirectLink = _ref.signInRedirectLink,
    _ref$signIn = _ref.signIn,
    signIn = _ref$signIn === void 0 ? {} : _ref$signIn,
    _ref$signOut = _ref.signOut,
    signOut = _ref$signOut === void 0 ? {} : _ref$signOut,
    loginState = _ref.loginState,
    _ref$homepageLink = _ref.homepageLink,
    homepageLink = _ref$homepageLink === void 0 ? '' : _ref$homepageLink,
    _ref$mobileData = _ref.mobileData;
  _ref$mobileData = _ref$mobileData === void 0 ? {} : _ref$mobileData;
  var icons = _ref$mobileData.icons,
    _ref$mobileData$botto = _ref$mobileData.bottomLinks,
    bottomLinks = _ref$mobileData$botto === void 0 ? {} : _ref$mobileData$botto,
    _ref$mobileData$items = _ref$mobileData.items,
    items = _ref$mobileData$items === void 0 ? [] : _ref$mobileData$items;
  var _bottomLinks$contactU = bottomLinks.contactUsText,
    contactUsText = _bottomLinks$contactU === void 0 ? '' : _bottomLinks$contactU,
    _bottomLinks$contactU2 = bottomLinks.contactUsLink,
    contactUsLink = _bottomLinks$contactU2 === void 0 ? '' : _bottomLinks$contactU2,
    _bottomLinks$signInTe = bottomLinks.signInText,
    signInText = _bottomLinks$signInTe === void 0 ? '' : _bottomLinks$signInTe,
    _bottomLinks$signInIc = bottomLinks.signInIcon,
    signInIcon = _bottomLinks$signInIc === void 0 ? '' : _bottomLinks$signInIc,
    _bottomLinks$signInLi = bottomLinks.signInLink,
    signInLink = _bottomLinks$signInLi === void 0 ? '' : _bottomLinks$signInLi;
  if (items.length === 0) return null;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("ul", {
    className: "cmp-mobile-navigation__group"
  }, items.map(function (item, index) {
    var key = "mobile-nav-" + index;
    return _react.default.createElement(_mobileNavListItem.default, (0, _extends2.default)({}, item, {
      key: key,
      icons: icons
    }));
  })), _react.default.createElement("div", {
    className: "bottom-links"
  }, _react.default.createElement("div", {
    className: "menu-nav2-contact-us"
  }, contactUsText && contactUsLink && _react.default.createElement("div", {
    className: "cmp-button--secondary cmp-contact-us"
  }, _react.default.createElement(_Anchor.default, {
    to: contactUsLink,
    id: "contact-waters-button",
    "data-locator": "contact-waters-link",
    elementLocator: "link-shopping-cart-empty-continue-shopping"
  }, _react.default.createElement(_Button.default, {
    className: "secondary",
    elementLocator: "contact-waters-button"
  }, contactUsText)))), _react.default.createElement("div", {
    className: "menu-nav2-sign-in-out"
  }, signInText && signInLink && _react.default.createElement(_signInOut.default, {
    signIn: signIn,
    signOut: signOut,
    loginState: loginState,
    signInAuthorText: signInText,
    signInAuthorLink: signInLink,
    signInOutIcon: signInIcon,
    homepageLink: homepageLink,
    signOutRequest: signOutRequest,
    signInRedirectLink: signInRedirectLink
  }))));
}
var _default = MobileNavListItems;
exports.default = _default;
module.exports = exports["default"];